var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    fill: "#DC3546"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.7148 35.1934C28.9746 35.7129 29.4941 36.0469 30.125 36.0469H34.875V37.5312C34.875 38.0508 34.4668 38.4219 33.9844 38.4219H21.5156C20.9961 38.4219 20.625 38.0508 20.625 37.5312V20.3125C20.625 19.8301 20.9961 19.4219 21.5156 19.4219H28.9375V24.4688C28.9375 24.9883 29.3086 25.3594 29.8281 25.3594H34.875V27.1035L30.125 31.8164V34.8594C29.9766 34.8594 29.8281 34.7852 29.7539 34.6367C29.3086 33.7461 28.0469 33.5234 27.3047 34.1172L26.7852 32.5586C26.6738 32.1875 26.3398 31.9648 25.9688 31.9648C25.5605 31.9648 25.2266 32.1875 25.1152 32.5586L24.4473 34.5996C24.373 34.748 24.2246 34.8594 24.0391 34.8594H23.5938C23.2598 34.8594 23 35.1562 23 35.4531C23 35.7871 23.2598 36.0469 23.5938 36.0469H24.0391C24.7441 36.0469 25.3379 35.6387 25.5605 34.9707L25.9688 33.7832L26.5625 35.6758C26.748 36.1582 27.416 36.1953 27.6758 35.75L27.9355 35.1562C28.0469 34.9707 28.2324 34.9336 28.3438 34.9336C28.418 34.9336 28.6035 34.9707 28.7148 35.1934ZM34.875 23.9492V24.1719H30.125V19.4219H30.3477C30.5703 19.4219 30.793 19.5332 30.9785 19.6816L34.6152 23.3184C34.7637 23.5039 34.875 23.7266 34.875 23.9492ZM31.3125 32.2988L37.3242 26.3242L39.8477 28.8477L33.8359 34.8594H31.3125V32.2988ZM41.7031 25.6562C42.0742 26.0273 42.0742 26.6211 41.7031 26.9922L40.7012 27.9941L38.1777 25.4707L39.1797 24.4688C39.5508 24.0977 40.1445 24.0977 40.5156 24.4688L41.7031 25.6562Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMark);
export default __webpack_public_path__ + "static/media/Mark.4cd63e4eb7a65adc6eab3526d733fee6.svg";
export { ForwardRef as ReactComponent };